import { nav } from "./nav";
import { hero } from "./hero";
import { dashboard } from "./dashboard";
import { faq } from "./faq";
import { footer } from "./footer";
import { pricing } from "./pricing";
import { howItWorks } from "./howItWorks";
import { favorites } from "./favorites";
import { memberProfile } from "./memberProfile";
import { incomingRequests } from "./incomingRequests";
import { migrated } from "./migrated";
import { countries } from "./countries";

export const common = {
  nav,
  hero,
  dashboard,
  faq,
  footer,
  pricing,
  howItWorks,
  favorites,
  memberProfile,
  incomingRequests,
  migrated,
  countries,
  corporate: {
    hero: {
      title: "Reinventare il viaggio",
      subtitle: "Una visione etica, locale e umana del turismo di domani.",
    },
    mission: {
      badge: "La nostra Missione",
      title: "Turismo equo",
      description:
        "Crediamo che viaggiare debba essere accessibile a tutti, senza intermediari costosi. DONKEY TRAVEL consente ai proprietari di viaggiare liberamente grazie al valore della propria propriet� .",
    },
    philosophy: {
      badge: "La nostra Filosofia",
      title: "Fatto in Francia e umano",
      description:
        "Radicati nella Valle della Somme, difendiamo un modello artigianale contro i giganti della tecnologia. Nessun algoritmo oscuro, solo buon senso e convivialit� .",
      values: {
        fair: {
          title: "Equo",
          desc: "0% di commissione sugli scambi. Solo un abbonamento trasparente.",
        },
        local: {
          title: "Radicamento Locale",
          desc: "Orgogliosi delle nostre radici francesi, promuoviamo un turismo rispettoso.",
        },
        community: {
          title: "Comunit� ",
          desc: "Un club privato di proprietari fidati che condividono gli stessi valori.",
        },
      },
    },
    team: {
      badge: "Il Team",
      title: "Appassionati al tuo servizio",
      subtitle:
        "Dietro la piattaforma, esseri umani che amano viaggiare e condividere.",
      members: {
        ceo: {
          name: "Plük",
          role: "Creatore di DONKEY TRAVEL • Sviluppatore • Airbnb Superhost da 4 anni",
          bio: "Per anni ho accolto viaggiatori nelle mie case, dove io stesso sarei potuto andare se DONKEY TRAVEL fosse esistito. Ecco perché ho creato DONKEY TRAVEL: per permettere agli host di accogliersi a vicenda e viaggiare diversamente.",
        },
        cto: {
          name: "Marie Martin",
          role: "CTO",
          bio: "Architetta della piattaforma, garante della sicurezza.",
        },
        cmo: {
          name: "Sophie Bernard",
          role: "Responsabile Comunicazione",
          bio: "La voce di DONKEY TRAVEL per la nostra comunit� .",
        },
      },
    },
    investors: {
      badge: "Investitori",
      title: "Unisciti all'avventura",
      description:
        "DONKEY TRAVEL è in piena crescita. Cerchiamo partner che condividano la nostra visione di un turismo sostenibile ed equo.",
      cta: "Contattaci per investire",
    },
  },
  trokOrigin: {
    badge: "Capire il concetto",
    title: "Come funziona esattamente?",
    subtitle:
      "Uno scambio diretto tra due persone, senza intermediari né sistemi di punti complicati",
    etymology: {
      title: "L'origine della parola",
      historicalTitle: "Una pratica millenaria",
      text1:
        'La parola "Troc" appare in francese nel XIV secolo, derivata dal verbo "troquer". Trova le sue radici nello spagnolo "trucque" e nel vallone "trouk", evocando l\'idea di scambio diretto.',
      text2:
        'Attestato dal 1364 sotto la forma "truke" in documenti anglo-normanni, poi ufficializzato nel 1464 nelle lettere patenti di Luigi XI: "per la vendita, scambio o scambio di tali merci".',
      text3:
        "In DONKEY TRAVEL, abbiamo mantenuto questa filosofia ancestrale: scambi direttamente la tua casa con un altro proprietario. Niente moneta virtuale, niente punti da accumulare. Solo un accordo tra due esseri umani.",
      from: "Etimologia",
      meaning: "Scambiare direttamente, da persona a persona",
      century14: "XIV secolo",
      firstAttestation: "Prima attestazione in francese",
      century15: "XV secolo",
      officialUse: "Uso ufficiale da parte di Luigi XI",
      today: "Oggi",
      modernPractice: "Pratica moderna e collaborativa",
    },
    direct: {
      title: "Solo scambio diretto",
      description:
        "A differenza dei sistemi a punti o crediti, DONKEY TRAVEL funziona sul principio del baratto puro. Negozia direttamente con un altro proprietario: le tue notti contro le sue. È l'essenza stessa del baratto come esiste dal XIV secolo.",
      result: "Scambio diretto convalidato!",
    },
    noTriangulation: {
      title: "Nessuna triangolazione",
      description:
        "Nessun sistema complesso dove A d�  a B che d�  a C. Qui è semplice: trovi qualcuno, negoziate insieme (date simultanee o differite), scambiate. Punto.",
      noPoints: "Nessun punto da contare",
    },
    meetHost: {
      title: "Incontra un altro ospitante Airbnb",
      description:
        "DONKEY TRAVEL non è solo scoprire una casa o viaggiare. È soprattutto incontrare un altro appassionato di accoglienza, qualcuno che condivide i tuoi valori di ospitalit� . Il baratto è sempre stato una pratica sociale prima che economica.",
      share: "Condividi le tue esperienze da ospitante",
      tips: "Scambia i tuoi migliori consigli",
      friendship: "Crea amicizie durature",
      badge: "Comunit�  di ospitanti",
      badgeSub: "Incontri autentici",
      step2Title: "2. Contratto amichevole su DONKEY TRAVEL",
      step2Desc:
        "Firmano il contratto di scambio direttamente sulla piattaforma e ricevono il PDF via email. Tutto è sicuro e ufficiale.",
      contractSigned: "Contratto firmato e sicuro",
      step3Title: "3. Marie arriva a Parigi (2 settimane dopo)",
      step3Desc:
        "Jean accoglie Marie calorosamente. È impressionato: l'appartamento è impeccabile, Marie rispetta tutto. Che differenza con certi viaggiatori Airbnb! Discutono delle loro esperienze da ospitante davanti a un caffè.",
      step4Title: "4. Jean scopre Reims (6 mesi dopo)",
      step4Desc:
        "Jean arriva all'alloggio di Marie a Reims. Il contesto è magnifico! Marie lo invita a cena, mangiano insieme e rifanno il mondo parlando di viaggi, di Airbnb e dei loro migliori aneddoti da ospitante.",
      step5Title: "5. Un'amicizia duratura",
      step5Desc:
        "Marie e Jean rimangono in contatto. Decidono di scambiarsi regolarmente le loro case. Più che un semplice scambio, è nata una vera amicizia grazie a TRAVELTROK.",
      spiritTitle: "Ecco lo spirito DONKEY TRAVEL!",
      spiritDesc:
        "Scambi autentici tra proprietari appassionati, nel rispetto e nella convivialit� . Niente punti, niente triangolazione, solo vero baratto alla vecchia maniera.",
    },
    negotiation: {
      badge: "Negoziazione ludica",
      title: "Negozia come un gioco!",
      description:
        "10 notti contro 5? Perché no! Fai un'offerta, ricevi una controfferta, trova un accordo. Il tutto in uno spirito bonario. Come ai tempi dei primi scambi, la negoziazione fa parte del piacere.",
      marieProperty: "Alloggio a Reims",
      jeanProperty: "Appartamento a Parigi",
      marieLocation: "Nel suo alloggio a Reims",
      jeanLocation: "Nel suo appartamento a Parigi",
      marieAccepts: "Marie accetta l'offerta",
      offers: "Offerta",
      proposes: "Propone",
      nights: "notti",
      status: {
        initial: "Marie fa un'offerta...",
        counter: "Jean fa una controfferta!",
        negotiate: "Marie negozia...",
        deal: "Affare fatto! 🎉",
      },
      chat: {
        msg1: "Ti propongo {{marieNights}} notti nel mio alloggio a Reims contro {{jeanNights}} notti a Parigi!",
        msg2: "Jean trova l'alloggio di Marie molto bello...",
        msg3: "Il tuo alloggio è magnifico! Sono simpatico, ti propongo {{jeanNights}} notti a Parigi 😊",
        msg4: "Affare fatto! 🤝",
        msg5: "Marie guarda le disponibilit�  di Jean...",
      },
      nextStep: "Passo successivo",
      restart: "Ricominciare",
      points: {
        flexible: "Negoziazione flessibile",
        friendly: "Atmosfera conviviale",
        fair: "Accordo equo",
      },
    },
    flexibility: {
      title: "Flessibilit�  totale",
      description:
        "A differenza degli scambi tradizionali, non hai bisogno di trovare qualcuno che voglia la tua casa esattamente quando tu vuoi la sua. Accumula Scambio e usali quando vuoi!",
    },
    example: {
      person1: "Marie",
      location1: "Parigi, Francia",
      person2: "Jean",
      location2: "Lione, Francia",
      result: "Scambio riuscito!",
    },
  },
  exchange: {
    title: "Come funziona?",
    subtitle:
      "Un sistema semplice e sicuro per scambiare le vostre case in completa fiducia",
    features: {
      secure: {
        title: "Scambi sicuri",
        description:
          "Tutti i membri sono verificati e le recensioni garantiscono la trasparenza di ogni scambio.",
      },
      sync: {
        title: "Sincronizzazione calendario",
        description:
          "Sincronizza automaticamente le tue disponibilit�  con il tuo calendario Airbnb esistente.",
      },
      global: {
        title: "Rete europea",
        description:
          "Accedi ai membri host nei paesi europei disponibili su TRAVELTROK.",
      },
      chat: {
        title: "Messaggistica integrata",
        description:
          "Comunica direttamente con gli altri proprietari per organizzare i tuoi scambi.",
      },
      rating: {
        title: "Sistema di valutazione",
        description:
          "Consulta le recensioni e le valutazioni per scegliere i tuoi partner di scambio in completa fiducia.",
      },
      savings: {
        title: "Risparmi garantiti",
        description:
          "Viaggia gratuitamente usando i tuoi Scambio invece di pagare alloggi costosi.",
      },
    },
    steps: {
      title: "In 3 semplici passaggi",
      step1: {
        title: "Crea il tuo profilo",
        description:
          "Iscriviti e aggiungi le informazioni sul tuo alloggio Airbnb in pochi minuti.",
      },
      step2: {
        title: "Trova la tua destinazione",
        description:
          "Sfoglia gli alloggi disponibili e trova la destinazione dei tuoi sogni.",
      },
      step3: {
        title: "Scambia e viaggia",
        description:
          "Proponi uno scambio, conferma le date e goditi il tuo soggiorno gratuitamente!",
      },
    },
  },
  worldMap: {
    title: "Top 20 dei paesi più attivi",
    subtitle: "Scopri i paesi dove gli scambi di casa sono più popolari oggi",
    description:
      "La nostra comunit�  cresce ogni giorno con nuovi proprietari in tutto il mondo. Scopri dove potresti viaggiare gratuitamente.",
    badge: "Classifica in tempo reale",
    properties: "alloggi",
    cta: "Vedi tutte le destinazioni",
    exchangesToday: "Scambi oggi",
    activeCountries: "Paesi attivi",
    vsYesterday: "vs. ieri",
    fullRanking: "Classifica completa",
    countries: {
      Guadeloupe: "Guadalupa",
      Martinique: "Martinica",
      Guyane: "Guyana Francese",
      "La Réunion": "Riunione",
      Mayotte: "Mayotte",
      "Polynésie française": "Polinesia Francese",
      "Nouvelle-Calédonie": "Nuova Caledonia",
      "Îles Canaries": "Isole Canarie",
      "Ceuta & Melilla": "Ceuta e Melilla",
      Madère: "Madera",
      Açores: "Azzorre",
      Aruba: "Aruba",
      Curaçao: "Curaçao",
      "Saint-Martin": "Sint Maarten",
      Bermudes: "Bermuda",
      "Îles Caïmans": "Isole Cayman",
      Gibraltar: "Gibilterra",
      france: "Francia",
      spain: "Spagna",
      italy: "Italia",
      usa: "Stati Uniti",
      uk: "Regno Unito",
      germany: "Germania",
      portugal: "Portogallo",
      netherlands: "Paesi Bassi",
      canada: "Canada",
      australia: "Australia",
      belgium: "Belgio",
      switzerland: "Svizzera",
      greece: "Grecia",
      mexico: "Messico",
      brazil: "Brasile",
      austria: "Austria",
      croatia: "Croazia",
      thailand: "Thailandia",
      morocco: "Marocco",
    },
  },
  calendar: {
    title: "Sincronizzazione automatica con Airbnb",
    subtitle: "Collega il tuo calendario Airbnb in un clic",
    description:
      "Le tue disponibilit�  si sincronizzano automaticamente. Non serve più gestire due calendari separatamente.",
    features: {
      sync: {
        title: "Sincronizzazione bidirezionale",
        description:
          "I tuoi calendari Airbnb e DONKEY TRAVEL rimangono sempre aggiornati automaticamente",
      },
      realtime: {
        title: "Aggiornamenti in tempo reale",
        description:
          "Ogni modifica è istantaneamente sincronizzata su entrambe le piattaforme",
      },
      smart: {
        title: "Gestione intelligente",
        description:
          "Evita le doppie prenotazioni grazie al nostro sistema di sincronizzazione avanzato",
      },
    },
    cta: "Collega il mio calendario",
  },
  airbnb: {
    title: "Gi�  proprietario Airbnb?",
    subtitle: "Unisciti a DONKEY TRAVEL e inizia a viaggiare gratuitamente",
    description:
      "Importa automaticamente le informazioni del tuo alloggio Airbnb e inizia a scambiare oggi stesso.",
    features: {
      verification: {
        title: "Verifica automatica del tuo profilo",
      },
      import: {
        title: "Importazione delle tue foto e descrizioni",
      },
      trust: {
        title: "Unisciti a una comunit�  di fiducia",
      },
    },
    cta: "Collega il mio Airbnb",
  },
  membersMap: {
    title: "Mappa dei Membri",
    searchPlaceholder: "Cerca una destinazione, citt� ...",
    filters: "Filtri",
    radius: "Raggio",
    radiusAuto: "Automatico",
    reset: "Resetta",
    filterPets: "Animali ammessi",
    filterVerified: "Ospitanti verificati",
    filterRating: "4.8+",
    filterAllTypes: "Tutti i tipi",
    oneTraveler: "1 viaggiatore",
    multipleTravelers: "{{count}} viaggiatori",
    dates: "Date",
    addDates: "Aggiungi date",
    startDate: "Partenza",
    endDate: "Ritorno",
    listingsTitle: "Alloggi",
    listingsSubtitle: "Seleziona per vedere sulla mappa.",
    pagination: "{{current}} / {{total}}",
    clearFilters: "Cancella filtri",
    guestsShort: "p.",
    bedroomsShort: "cam.",
    surfaceAreaUnit: "m²",
    perNight: "/ notte",
    online: "In linea",
    offline: "Non in linea",
    verified: "Verificato",
    favorite: "Preferito",
    favorites: "Preferiti",
    members: "Membri",
    exchanges: "scambi",
    rooms: "stanze",
    mapTitle: "Mappa interattiva dei membri DONKEY TRAVEL",
    countries: "Paesi",
    results: "risultati",
    viewProfile: "Vedi profilo",
    proposeExchange: "Proponi scambio",
    showFavoritesOnly: "Mostra solo i preferiti",
    advancedSearch: "Ricerca avanzata",
    refineSearch: "Affina la tua ricerca",
    activeFilter: "filtro attivo",
    activeFilters: "filtri attivi",
    availabilityDates: "Date di disponibilit� ",
    quickPeriods: "Periodi rapidi",
    thisMonth: "Questo mese",
    nextMonth: "Prossimo mese",
    next3Months: "Prossimi 3 mesi",
    summer: "Estate",
    autumn: "Autunno",
    winter: "Inverno",
    arrival: "Arrivo",
    departure: "Partenza",
    flexibleDates: "Date flessibili",
    clear: "Cancella",
    propertyTypeTitle: "Tipo di alloggio",
    apartment: "Appartamento",
    house: "Casa",
    villa: "Villa",
    loft: "Loft",
    capacityAndRooms: "Capacit�  & stanze",
    numberOfTravelers: "Numero di viaggiatori",
    all: "Tutti",
    numberOfRooms: "Numero di stanze",
    minimumSurface: "Superficie minima",
    equipments: "Servizi",
    wifi: "Wi‑Fi",
    pool: "Piscina",
    parking: "Parcheggio",
    airConditioning: "Aria condizionata",
    garden: "Giardino",
    terrace: "Terrazza",
    fireplace: "Camino",
    barbecue: "Barbecue",
    bike: "Bici",
    sauna: "Sauna",
    gym: "Palestra",
    washingMachine: "Lavatrice",
    statusAvailability: "Stato & disponibilit� ",
    onlineAvailability: "Disponibilit�  in tempo reale",
    onlineOnly: "Solo in linea",
    verifiedMembersOnly: "Solo membri verificati",
    ratingExperience: "Voto & esperienza",
    minimumRating: "Voto minimo",
    minimumExchanges: "Scambi minimi",
    matchingMembers: "membri corrispondenti",
    matchingMember: "membro corrispondente",
    seeResults: "Vedi i",
    result: "risultato",
    resetAllFilters: "Resetta tutti i filtri",
    rating: "Voto",
    travelers: "Viaggiatori",
    contact: "Contattare",
    searchMemberCity: "Cerca un membro, citt� , paese...",
    noFavorite: "Nessun preferito",
    addFavoritesHint: "Aggiungi membri ai preferiti cliccando sul cuore",
    noMemberFound: "Nessun membro trovato",
    tryModifyFilters: "Prova a modificare i tuoi filtri",
    viewAllMembers: "Vedi tutti i membri",
    modifyFilters: "Modifica filtri",
    favoritesOnly: "Solo preferiti",
    addToFavorites: "Aggiungi ai preferiti",
    removeFromFavorites: "Rimuovi dai preferiti",
    loading: "Caricamento...",
    sortBy: "Ordina per",
    relevance: "Pertinenza",
    newest: "Più recenti",
    noResults: "Nessun risultato trovato",
    tryDifferentFilters: "Prova ad adattare i tuoi filtri di ricerca",
    membersList: "Lista dei membri",
    membersFound: "membri trovati",
    visibleMembers: "Membri visibili",
    legend: "Legenda",
    availableProperty: "Alloggio disponibile",
    selected: "Selezionato",
    visibleByAll: "Visibile a tutti",
    allMembersSeeYou: "Tutti i membri ti vedono",
    targetedMode: "Modalit�  mirata",
    countriesSelected: "paesi selezionati",
    countrySelected: "paese selezionato",
    myVisibility: "La mia visibilit� ",
    whoCanSee: "Chi può vedere il mio alloggio sulla mappa?",
    visibleByAllTitle: "Visibile a tutti",
    visibleByAllDesc:
      "Tutti i membri della comunit�  possono vedere il tuo alloggio e proporti uno scambio.",
    visibleByAllHint: "Massima visibilit�  e opportunit� ",
    active: "ATTIVO",
    targetedModeTitle: "Modalit�  mirata",
    targetedModeDesc:
      "Solo i membri dei paesi che cerchi possono vedere il tuo alloggio. Massima discrezione.",
    targetedModeHint: "Vedi e sei visto solo dalle tue destinazioni",
    myDesiredDestinations: "Le mie destinazioni desiderate",
    clearAll: "Cancella tutto",
    searchCountry: "Cerca un paese...",
    member: "membro",
    membersCount: "membri",
    noCountryFound: "Nessun paese trovato",
    targetedInfoTitle: "Il tuo alloggio apparir�  solo ai membri in",
    targetedInfoDesc: "Gli altri non ti vedranno sulla mappa.",
    targetedExample:
      "Esempio: se vuoi andare solo in Olanda, solo i membri olandesi vedranno il tuo profilo.",
    selectAtLeastOneCountry:
      "Seleziona almeno un paese per attivare la modalit�  mirata.",
    propertyTypes: {
      appartement: "Appartamento",
      maison: "Casa",
      villa: "Villa",
      loft: "Loft",
      luxe: "Lusso",
      insolite: "Insolito",
    },
    pricePerNight: "PREZZO PER NOTTE (€)",
    min: "Min",
    max: "Max",
    sortResults: "ORDINA RISULTATI",
    sort: {
      recommended: "✨ Consigliati",
      priceAsc: "💎 Prezzo crescente",
      priceDesc: "💎 Prezzo decrescente",
    },
    amenitiesTitle: "SERVIZI",
    amenitiesTabs: {
      all: "TUTTI",
      essentials: "ESSENZIALI",
      features: "COMFORT",
      location: "POSIZIONE",
      safety: "SICUREZZA",
    },
  },
  amenities: {
    wifi: "Wifi",
    tv: "TV",
    kitchen: "Cucina",
    washing_machine: "Lavatrice",
    ac: "Aria condizionata",
    heating: "Riscaldamento",
    workspace: "Spazio di lavoro",
    iron: "Ferro da stiro",
    hair_dryer: "Asciugacapelli",
    pool: "Piscina",
    hottub: "Idromassaggio",
    patio: "Terrazza",
    bbq: "Barbecue",
    parking: "Parcheggio gratuito",
    gym: "Palestra",
    fireplace: "Camino",
    breakfast: "Colazione",
    beachfront: "Fronte spiaggia",
    ski_in_out: "Accesso diretto alle piste",
    lake_access: "Accesso al lago",
    smoke_detector: "Rilevatore di fumo",
    first_aid: "Kit di pronto soccorso",
    fire_extinguisher: "Estintore",
  },
  destinations: {
    title: "Destinazioni",
    searchPlaceholder: "Cerca una destinazione...",
    destinationsFound: "destinazioni trovate",
    noResults: "Nessun risultato",
    tryDifferentSearch: "Prova un'altra ricerca",
    sortMembers: "Più membri",
    sortProperties: "Più alloggi",
    sortName: "Nome (A-Z)",
    all: "Tutti",
    members: "membri",
    properties: "alloggi",
    explore: "Esplora questa destinazione",
    stats: {
      destinations: "Destinazioni",
      members: "Membri",
      properties: "Alloggi",
      countries: "Paesi",
    },
    countriesIn: "Paesi in",
    selectCountry: "— seleziona un paese per filtrare",
    continents: {
      Europe: "Europa",
      "Amérique du Nord": "Nord America",
      "Amérique du Sud": "Sud America",
      Asie: "Asia",
      Afrique: "Africa",
      Océanie: "Oceania",
    },
    countries: {
      Turquie: "Turchia",
      France: "Francia",
      "Pays-Bas": "Paesi Bassi",
      "Royaume-Uni": "Regno Unito",
      Espagne: "Spagna",
      Italie: "Italia",
      Tchéquie: "Repubblica Ceca",
      Grèce: "Grecia",
      Portugal: "Portogallo",
      Autriche: "Austria",
      Écosse: "Scozia",
      Hongrie: "Ungheria",
      Croatie: "Croazia",
      Danemark: "Danimarca",
      Suède: "Svezia",
      Suisse: "Svizzera",
      Belgique: "Belgio",
      Norvège: "Norvegia",
      Irlande: "Irlanda",
      Pologne: "Polonia",
      Finlande: "Finlandia",
      Islande: "Islanda",
      Roumanie: "Romania",
      Monténégro: "Montenegro",
      "États-Unis": "Stati Uniti",
      Canada: "Canada",
      Mexique: "Messico",
      "Costa Rica": "Costa Rica",
      Cuba: "Cuba",
      "Rép. Dominicaine": "Rep. Dominicana",
      Guatemala: "Guatemala",
      Brésil: "Brasile",
      Argentine: "Argentina",
      Pérou: "Perù",
      Colombie: "Colombia",
      Chili: "Cile",
      Équateur: "Ecuador",
      Uruguay: "Uruguay",
      Bolivie: "Bolivia",
      Chine: "Cina",
      Thaïlande: "Thailandia",
      Indonésie: "Indonesia",
      Vietnam: "Vietnam",
      "Corée du Sud": "Corea del Sud",
      Inde: "India",
      Cambodge: "Cambogia",
      Jordanie: "Giordania",
      Maldives: "Maldive",
      "Sri Lanka": "Sri Lanka",
      Népal: "Nepal",
      Philippines: "Filippine",
      Ouzbékistan: "Uzbekistan",
      Égypte: "Egitto",
      Maroc: "Marocco",
      "Afrique du Sud": "Sudafrica",
      Tanzanie: "Tanzania",
      Kenya: "Kenya",
      Sénégal: "Senegal",
      Madagascar: "Madagascar",
      Tunisie: "Tunisia",
      Zimbabwe: "Zimbabwe",
      Namibie: "Namibia",
      "Île Maurice": "Mauritius",
      Rwanda: "Ruanda",
      Australie: "Australia",
      "Nouvelle-Zélande": "Nuova Zelanda",
      "Polynésie française": "Polinesia Francese",
      Fidji: "Figi",
      "Nouvelle-Calédonie": "Nuova Caledonia",
      Samoa: "Samoa",
    },
    cities: {
      Paris: "Parigi",
      "Mont Saint-Michel": "Mont Saint-Michel",
      Marseille: "Marsiglia",
      Amsterdam: "Amsterdam",
      Londres: "Londra",
      Barcelone: "Barcellona",
      Madrid: "Madrid",
      Venise: "Venezia",
      Rome: "Roma",
      "Côte Amalfitaine": "Costiera Amalfitana",
      Prague: "Praga",
      Santorin: "Santorini",
      Athènes: "Atene",
      Lisbonne: "Lisbona",
      Porto: "Porto",
      Vienne: "Vienna",
      Édimbourg: "Edimburgo",
      Budapest: "Budapest",
      Dubrovnik: "Dubrovnik",
      Copenhague: "Copenaghen",
      Stockholm: "Stoccolma",
      Zermatt: "Zermatt",
      Bruges: "Bruges",
      Bergen: "Bergen",
      Dublin: "Dublino",
      Cracovie: "Cracovia",
      Helsinki: "Helsinki",
      Reykjavik: "Reykjavik",
      Bucarest: "Bucarest",
      Kotor: "Kotor",
      "New York": "New York",
      "San Francisco": "San Francisco",
      "Los Angeles": "Los Angeles",
      Miami: "Miami",
      Hawaï: "Hawaii",
      Vancouver: "Vancouver",
      Montréal: "Montreal",
      Toronto: "Toronto",
      Banff: "Banff",
      Québec: "Québec",
      Cancún: "Cancún",
      "Mexico City": "Citt�  del Messico",
      "San José": "San José",
      "La Havane": "L'Avana",
      "Punta Cana": "Punta Cana",
      Antigua: "Antigua",
      "Buenos Aires": "Buenos Aires",
      "Rio de Janeiro": "Rio de Janeiro",
      "São Paulo": "San Paolo",
      "Machu Picchu": "Machu Picchu",
      Lima: "Lima",
      Carthagène: "Cartagena",
      Bogotá: "Bogot� ",
      Santiago: "Santiago",
      Quito: "Quito",
      Montevideo: "Montevideo",
      "La Paz": "La Paz",
      Tokyo: "Tokyo",
      Kyoto: "Kyoto",
      Pékin: "Pechino",
      Shanghai: "Shanghai",
      "Hong Kong": "Hong Kong",
      Bangkok: "Bangkok",
      "Chiang Mai": "Chiang Mai",
      Bali: "Bali",
      "Hô Chi Minh-Ville": "Ho Chi Minh",
      Séoul: "Seul",
      "Angkor Wat": "Angkor Wat",
      Colombo: "Colombo",
      Katmandou: "Kathmandu",
      Manille: "Manila",
      Samarcande: "Samarcanda",
      Petra: "Petra",
      "Le Caire": "Il Cairo",
      Marrakech: "Marrakech",
      Chefchaouen: "Chefchaouen",
      "Le Cap": "Citt�  del Capo",
      Johannesburg: "Johannesburg",
      Zanzibar: "Zanzibar",
      "Safari Masai Mara": "Safari Masai Mara",
      Nairobi: "Nairobi",
      Dakar: "Dakar",
      Antananarivo: "Antananarivo",
      Tunis: "Tunisi",
      "Chutes Victoria": "Cascate Vittoria",
      Windhoek: "Windhoek",
      "Île Maurice": "Mauritius",
      Kigali: "Kigali",
      Sydney: "Sydney",
      Melbourne: "Melbourne",
      "Grande Barrière de Corail": "Grande Barriera Corallina",
      Auckland: "Auckland",
      Queenstown: "Queenstown",
      "Bora Bora": "Bora Bora",
      Fidji: "Figi",
      Nouméa: "Nouméa",
      Apia: "Apia",
      "Baie d'Halong": "Baia di Ha Long",
      Maldives: "Maldive",
    },
  },
  story: {
    badge: "Una storia vera",
    title: "Chloé & Hugo: lo scambio perfetto",
    subtitle:
      "Quando una parigina stanca della citt�  incontra un campagnolo che sogna Parigi...",
    chloé: {
      aptAlt: "Appartamento di Chloé a Parigi",
      quotaExceeded: "Quota Airbnb superata!",
      role: "Ospitante Airbnb a Parigi",
      speech1:
        'Ho <strong class="text-red-600">superato la mia quota di 120 notti</strong>... Impossibile affittare. E onestamente, sono stanca del rumore parigino. 😩',
      nightsTag: "120/120 notti",
      tiredTag: "Stanca di Parigi",
      dreamsOf: "Chloé sogna...",
      dreamTitle: "La calma della campagna",
      dreamDesc: "Verde, silenzio, una sauna... il paradiso!",
      searching: "Cerca un alloggio in campagna",
      findsLuc: "Trova Hugo!",
      speech2:
        "Finalmente la calma! La sauna dopo una passeggiata nel bosco, è la <strong>felicit�  assoluta</strong>. 🌿✨",
      review:
        "L'alloggio di Hugo è un piccolo paradiso! La sauna dopo una passeggiata nel bosco, è la felicit� . Siamo diventati amici! Raccomando al 200%.",
    },
    hugo: {
      giteAlt: "Alloggio di Hugo in campagna",
      available: "Disponibile tutto l'anno",
      location: "Campagna, Francia",
      role: "Ospitante Airbnb in campagna",
      speech1:
        'Il mio alloggio ha un <strong class="text-sage-600">giardino, una sauna e una poltrona massaggiante</strong>... ma non ne posso più della campagna. Sogno Parigi! 🗼',
      dreamsOf: "Hugo sogna...",
      dreamTitle: "Le luci di Parigi",
      dreamDesc: "I musei, i caffè, la Torre Eiffel... finalmente!",
      searching: "Cerca un appartamento a Parigi",
      findsMaya: "Trova Chloé!",
      speech2:
        "Parigi, finalmente! Il Louvre, i bistrot, i tetti... è <strong>magico</strong>! 🗼🥐",
      review:
        "L'appartamento di Chloé è incredibile, vista sui tetti di Parigi! E tutto questo senza toccare la sua quota. Lo scambio è geniale!",
    },
    tags: {
      garden: "Giardino",
      sauna: "Sauna",
      massage: "Massaggio",
      countryside: "Campagna",
      bigGarden: "Grande giardino",
      restaurants: "Ristoranti",
      museums: "Musei",
    },
    match: {
      spark: "La scintilla!",
      title: "Scoprono DONKEY TRAVEL",
      perfect: "Match perfetto!",
    },
    quota: {
      title: "Fuori quota Airbnb = 100% gratuito!",
      description:
        "Il soggiorno di Hugo non intacca la quota di Chloé. È uno scambio, non un affitto. Tutti ci guadagnano!",
      totalCost: "Costo totale",
      quotaNight: "Notte quota",
    },
    happyEnd: {
      title: "Tutti sono felici! 🎊",
      subtitle:
        "Chloé e Hugo sono diventati amici. Condividono i loro consigli da host e pianificano gi�  un prossimo scambio!",
      exchangeSuccess: "Scambio riuscito",
      newFriendship: "Nuova amicizia",
      outsideQuota: "Fuori quota",
      free: "100% gratuito",
    },
  },
  messaging: {
    messages: "Messaggi",
    searchPlaceholder: "Cerca una conversazione...",
    all: "Tutti",
    unread: "Non letti",
    archived: "Archiviati",
    online: "In linea",
    offline: "Non in linea",
    messagePlaceholder: "Scrivi un messaggio...",
    writeMessage: "Scrivi un messaggio",
    sending: "Invio in corso...",
    characters: "caratteri",
    noConversation: "Nessuna conversazione",
    notificationMessage: "Nuovo messaggio",
    quickActions: "Azioni rapide",
    proposeExchange: "Proponi uno scambio",
    proposeExchangeTitle: "Proposta di scambio",
    checkAvailability: "Verifica disponibilit� ",
    report: "Segnala",
    hisProperty: "Il suo alloggio",
    rooms: "camere",
    guests: "viaggiatori",
    verifiedOwner: "Proprietario verificato",
    viewAirbnbListing: "Vedi annuncio Airbnb",
    details: "Dettagli",
    desiredDates: "Date desiderate",
    arrival: "Arrivo",
    departure: "Partenza",
    period: "Periodo",
    duration: "Durata",
    nights: "notti",
    numberOfTravelers: "Numero di viaggiatori",
    traveler: "viaggiatore",
    travelers: "viaggiatori",
    person: "persona",
    persons: "persone",
    dateFlexibility: "Flessibilit�  date",
    exactDates: "Date esatte",
    flex1to2: "± 1-2 giorni",
    flex3to5: "± 3-5 giorni",
    flexWeek: "± 1 settimana",
    personalMessage: "Messaggio personale",
    summary: "Riepilogo",
    termsAccept: "Accetto le condizioni di scambio di DONKEY TRAVEL",
    sendProposal: "Invia proposta",
    proposalSent: "Proposta inviata!",
    proposalSentMessage: "La tua proposta è stata inviata con successo",
    close: "Chiudi",
    today: "Oggi",
    selectConversation: "Seleziona una conversazione",
    selectConversationHint: "Scegli un proprietario per iniziare a chattare",
  },
  destination_introuvable: `Destinazione non trovata`,
  cette_destination_n_apos_existe_pas_ou_a__t__d_pla: `Questa destinazione non esiste o è stata spostata.`,
  retour_aux_destinations: `Ritorno alle destinazioni`,
  pr_t___d_couvrir_: `Pronti a scoprire`,
  r_server_ce_s_jour: `Prenota questo soggiorno`,
  explorer_d_apos_autres_destinations: `Esplora altre destinazioni`,
  acc_s_r_serv_: `Accesso riservato`,
  europe_unique: `Europa unica`,
  "50eur_an_pour__changer_dans_toute_l_europe_": `50EUR/anno per lo scambio in tutta Europa.`,
  lancement_2026: `Lancio 2026`,
  club_d__change_h_tes_airbnb: `Club Scambio Host Airbnb`,
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes: `Ottimizza i tuoi periodi non di punta grazie agli scambi`,
  rejoindre_le_club: `Unisciti al club`,
  trouver_un_h_te: `Trova un host`,
  r_serv__aux_h_tes_traveltrok: `Riservato agli ospiti DONKEY TRAVEL`,
  voyagez_gratuitement_gr_ce___votre_logement: `Viaggia gratis con il tuo alloggio`,
  accueillez_des_membres_et_faites_vous_accueillir_e: `Accogli i membri e sarai il benvenuto. Uno scambio semplice, diretto e senza contanti tra proprietari.`,
  devenir_h_te: `Diventa un host`,
  comment__a_marche__: `Come funziona?`,
  amis_partageant_un_repas_en_corse: `Amici che mangiano in Corsica`,
  _nous_avons__chang__notre_maison___lyon_contre_une: `"Abbiamo scambiato la nostra casa a Lione con una villa in Corsica. Costo: 0€."`,
  sophie___marc__membres_depuis_2023: `Sophie & Marc, membri dal 2023`,
  pas_de_monnaie__pas_de_points__juste_un_accord_ent: `Niente monete, niente punti. Solo un accordo tra due proprietari. Io vengo a casa tua, tu vieni a casa mia.`,
  "1__accord_mutuel": `1. Accordo reciproco`,
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous: `Trovi un membro che ti piace e accetti di scambiare alloggio.`,
  "2__flexibilit__totale": `2. Flessibilit�  totale`,
  "3__z_ro_comptabilit_": `3. Contabilit�  zero`,
  pas_de_points___compter__juste_le_plaisir_de_parta: `Nessun punto da contare. Solo il piacere della condivisione e dell'incontro.`,
  pourquoi_les_h_tes_adorent_ce_syst_me__: `Perché gli host adorano questo sistema?`,
  plus_qu__une__conomie__c__est_une_nouvelle_fa_on_d: `Più che un'economia, è un nuovo modo di viaggiare.`,
  "0__de_frais": `Commissioni 0€`,
  les__changes_sont_totalement_gratuits__pas_de_frai: `Gli scambi sono completamente gratuiti. Nessun costo di servizio, nessun costo di pulizia (se non espressamente concordato).`,
  confiance_totale: `Fiducia totale`,
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac: `Solo gli host verificati possono commerciare. Stai accogliendo qualcuno che conosce il valore dell'abitazione.`,
  simplicit_: `Semplicit� `,
  oubliez_la_valeur_des_points__une_nuit_est_une_nui: `Dimentica il valore dei punti. Una notte è una notte. Lo scambio si basa sulla fiducia tra gli host.`,
  rejoignez_la_communaut__des_h_tes: `Unisciti alla comunit�  ospitante`,
  rejoignez_la_communaut__et_commencez____changer_: `Unisciti alla community e inizia a chattare.`,
  commencer_maintenant: `Inizia ora`,
  pr_nom_invalide: `Nome non valido`,
  nom_invalide: `Nome non valido`,
  email_invalide: `E-mail non valida`,
  s_lectionne_un_pays: `Seleziona un paese`,
  s_lectionne_un_mode_tarifaire: `Seleziona un metodo di prezzo`,
  s_lectionne_ton_usage: `Seleziona il tuo utilizzo`,
  tu_dois_accepter_les_conditions: `Devi accettare le condizioni`,
  france: `Francia`,
  belgique: `Belgio`,
  suisse: `Svizzera`,
  canada: `Canada`,
  allemagne: `Germania`,
  espagne: `Spagna`,
  italie: `Italia`,
  portugal: `Portogallo`,
  royaume_uni: `Regno Unito`,
  _tats_unis: `Stati Uniti`,
  autre: `Altro`,
  merci_de_corriger_les_champs_en_erreur_: `Correggi i campi errati.`,
  une_erreur_est_survenue__r_essaie_dans_quelques_in: `Si è verificato un errore. Riprova tra qualche istante.`,
  compte_cr___avec_succ_s: `Account creato con successo`,
  tu_recevras_un_email_pour_finaliser_ton_profil_voy: `Riceverai un'e-mail per finalizzare il tuo profilo di viaggiatore/ospitante.`,
  cr_er_un_autre_compte: `Crea un altro account`,
  activation_traveltrok: `Attivazione DONKEY TRAVEL`,
  choisis_ton_mode__voyageur__h_te__ou_usage_mixte_: `Scegli la tua modalit� : viaggiatore, host o uso misto.`,
  pr_nom: `Nome`,
  jeanne: `Jane`,
  nom: `Nome`,
  durand: `Durand`,
  email: `E-mail`,
  jeanne_email_com: `jeanne@email.com`,
  t_l_phone__optionnel_: `Telefono (facoltativo)`,
  pays: `Paese`,
  choisir_un_pays: `Scegli un paese`,
  mode_tarifaire: `Metodo di determinazione del prezzo`,
  voyageur: `Viaggiatore`,
  nuit: `notte`,
  h_te: `Ospite`,
  pro_multi_logements: `Multi-housing professionale`,
  mois: `mese`,
  usage_principal: `Uso principale`,
  je_voyage_principalement: `Viaggio principalmente`,
  je_loue_principalement: `Prevalentemente affitto`,
  je_fais_les_deux: `Faccio entrambe le cose`,
  nombre_de_logements: `Numero di alloggi`,
  logement: `alloggio`,
  logements: `alloggio`,
  a: `un`,
  j_accepte_les_conditions_d_utilisation_et_la_polit: `Accetto i termini di utilizzo e l'informativa sulla privacy.`,
  cr_ation_en_cours___: `Creazione in corso...`,
  cr_er_mon_compte_traveltrok: `Crea il mio account DONKEY TRAVEL`,
  r_servation_de_logements: `Prenotazione dell'alloggio`,
  support_h_te_prioritaire: `Supporto host prioritario`,
  carte___filtres_avanc_s: `Mappa + filtri avanzati`,
  flux_de_r_servation__tape_par__tape: `Flusso di prenotazione passo dopo passo`,
  couverture_dommages_assistance: `Copertura danni/assistenza`,
  multi_logements___reporting: `Multi-housing + reporting`,
  accueil: `Inizio`,
  tarifs: `Prezzi`,
  "0__commission_pour_les_h_tes": `Commissione 0% per gli host`,
  r_volution_traveltrok: `Rivoluzione DONKEY TRAVEL`,
  gardez_100__de_ce_que_vous_gagnez: `Conserva il 100% di ciò che guadagni`,
  simple: `Semplice`,
  tu_connais_ton_co_t_avant_de_r_server__aucun_effet: `Conosci il tuo costo prima di prenotare. Nessuna sorpresa al momento del pagamento.`,
  honn_te: `Onesto`,
  le_m_me_principe_pour_tous__voyageur_et_h_te_sont_: `Lo stesso principio per tutti: viaggiatore e ospitante sono trattati con la stessa regola.`,
  utile: `Utile`,
  je_suis_voyageur: `Sono un viaggiatore`,
  je_suis_h_te: `Sono un host`,
  j_ai_plusieurs_logements: `Ho diversi alloggi`,
  simulateur_comparatif_host: `Simulatore host comparativo`,
  compare_booking__airbnb_et_traveltrok_avec_tes_pro: `Confronta Booking, Airbnb e DONKEY TRAVEL con i tuoi dati.`,
  nombre_de_nuits: `Numero di notti`,
  property_price___night__eur_: `Prezzo dell'immobile/notte (EUR)`,
  autres_frais__m_nage__accueil__linge_____eur: `Altri costi (pulizia, reception, biancheria, ecc.) EUR`,
  option___qui_paie_les_frais__5____: `Opzione: chi paga le tasse (5%)?`,
  standard__recommand__: `Standard (consigliato)`,
  pro___attractivit_: `Pro / Attrattiva`,
  le_voyageur_paie_5__en_plus__vous_touchez_100__du_: `Il viaggiatore paga il 5% in più. Riceverai il 100% del prezzo.`,
  vous_payez_les_5___le_prix_affich__au_voyageur_est: `Paghi il 5%. Il prezzo visualizzato al viaggiatore è netto.`,
  base_de_calcul: `Base di calcolo`,
  nuit_s_: `notte/i`,
  autres_frais: `Altri costi`,
  montant_total_avant_commissions: `Importo totale prima delle commissioni`,
  plateforme: `Piattaforma`,
  frais_h_te: `Commissioni dell'host`,
  frais_voyageur: `Commissioni per i viaggiatori`,
  total_voyageur: `Viaggiatore totale`,
  net_h_te: `Ospite di rete`,
  avantage_fiscal___pro: `Vantaggio Fiscale e Pro`,
  consultez_votre_expert_comptable_: `Consulta il tuo commercialista.`,
  diff_rence_h_te__claire_et_vendeuse: `Differenza dell'host: chiaro e commerciale`,
  frais_h_te___an: `Tariffe host/anno`,
  _conomie_compar_e___booking: `Economia rispetto a Booking`,
  _conomie_vs_airbnb: `Economia contro Airbnb`,
  exemple_typique_sur_1_an__h_te_: `Esempio tipico su 1 anno (ospite)`,
  nuits_r_serv_es: `Notti riservate`,
  s_jours___an: `Soggiorni/anno`,
  chiffre_d_affaires_annuel: `Fatturato annuo`,
  frais_traveltrok: `Commissioni DONKEY TRAVEL`,
  frais_booking__15__: `Spese di prenotazione (15%)`,
  frais_airbnb__15_5__: `Commissioni Airbnb (15,5%)`,
  net_h_te_traveltrok: `Ospite della rete DONKEY TRAVEL`,
  comparatif_des_modes: `Confronto dei modi`,
  ce_que_tu_actives_selon_ton_usage_traveltrok_: `Cosa attivi in   base al tuo utilizzo di TRAVELTROK.`,
  fonction: `Funzione`,
  pro: `Pro`,
  cr_er_ton_compte_et_ton_mode_d_usage: `Crea il tuo account e la tua modalit�  di utilizzo`,
  choisis_si_tu_d_marres_en_voyageur__h_te__ou_les_d: `Scegli se iniziare come viaggiatore, host o entrambi. Puoi cambiare in qualsiasi momento.`,
  location_simple_c_t__voyageur: `Noleggio singolo lato passeggero`,
  recherche__filtres__r_servation_rapide_et_co_t_tra: `Ricerca, filtri, prenotazione rapida e costi trasparenti.`,
  gestion_h_te_simplifi_e: `Gestione host semplificata`,
  publie_ton_logement__g_re_ton_calendrier_et_r_pond: `Pubblica il tuo alloggio, gestisci il tuo calendario e rispondi velocemente alle richieste.`,
  couverture_incluse_pour_le_voyageur_et_pour_l_h_te: `Copertura inclusa per il viaggiatore e l'host.`,
  support_op_rationnel: `Supporto operativo`,
  accompagnement_en_cas_de_litige__annulation_ou_bes: `Supporto in caso di controversia, cancellazione o necessit�  di mediazione.`,
  faq_tarifs: `Domande frequenti sui prezzi`,
  vraiment_0__de_commission_pour_l_h_te__: `Davvero una commissione dello 0% per l'host?`,
  oui__l_h_te_re_oit_100__du_prix_qu_il_fixe__aucun_: `SÌ. L'host riceve il 100% del prezzo stabilito. Nessuna commissione di servizio, nessuna commissione di elaborazione.`,
  combien_paie_le_voyageur__: `Quanto paga il viaggiatore?`,
  le_voyageur_paie_une_commission_de_5__sur_le_monta: `Il viaggiatore paga una commissione del 5% sull'importo del noleggio. Questo copre i costi di gestione, l'assicurazione e il supporto.`,
  puis_je__changer_mon_logement_gratuitement__: `Posso scambiare il mio alloggio gratuitamente?`,
  oui___si_vous__tes_h_te__vous_pouvez__changer_votr: `SÌ ! Se sei un host, puoi scambiare il tuo alloggio con altri membri senza alcuna commissione (€0).`,
  pourquoi_ce_mod_le_est_il_moins_cher__: `Perché questo modello è più economico?`,
  en_ne_prenant_que_5__au_total__contre_15____20__ai: `Prendendo solo il 5% in totale (rispetto al 15-20% altrove), rendiamo i viaggi più accessibili pagando meglio gli host.`,
  pr_t___activer_ton_mode_traveltrok__: `Pronto per attivare la tua modalit�  DONKEY TRAVEL?`,
  voyageur__h_te__ou_hybride__commence_avec_une_logi: `Viaggiatore, host o ibrido: inizia con una logica chiara e costi controllati.`,
  cr_er_mon_compte: `Crea il mio account`,
  explorer_les_logements: `Esplora l'alloggio`,
  donn_es_personnelles: `Dati personali`,
  politique_de_confidentialit_: `Informativa sulla privacy`,
  rejoignez_notre_communaut__et_r_servez_un_logement: `Unisciti alla nostra community e prenota un alloggio su {{city}} con tariffe fisse chiare e assicurazione inclusa.`,
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_: `Una piattaforma di scambio europea riservata agli host Airbnb`,
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u: `Club privato per ospiti 4,5+: un abbonamento unico per scambiare in tutta Europa.`,
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_: `Riservato agli host Airbnb con valutazione maggiore o uguale a 4,5.`,
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu: `Riduzione del 50% nel 2026: 25EUR/anno invece di 50EUR/anno. Prezzo garantito a vita per le prime 1000 iscrizioni.`,
  basse_saison__pause__rencontres_entre_h_tes__conom: `Bassa stagione, soggiorni, incontri tra ospiti, risparmi sulle vacanze: tutto è pensato per gli ospiti attivi in   Europa.`,
  voyagez_moins_cher__5__de_frais___h_bergez_sans_fr: `Viaggia più economico (5% di commissioni), ospita gratuitamente (0%). Il modello più giusto sul mercato.`,
  fini_les_commissions_de_15__ou_plus__avec_traveltr: `Niente più commissioni del 15% o più. Con DONKEY TRAVEL gli host non pagano commissioni. I viaggiatori pagano solo il 5% di commissione di servizio. Questa è correttezza.`,
  hypoth_se_comparatif__booking_commission_h_te_15__: `Ipotesi comparativa: Commissione host prenotazione 15% (a seconda del paese e del programma), modalit�  Airbnb solo host 15,5% lato host e 0 lato viaggiatore.`,
  les_frais_de_5__peuvent__tre_d_ductibles_de_vos_ch: `La commissione del 5% può essere deducibile dalle tue spese se sei un'azienda. Il modello 0% semplifica la contabilit�  personale.`,
  avec_traveltrok__vous_pouvez_baisser_le_prix_de_vo: `Con DONKEY TRAVEL puoi abbassare il prezzo dei tuoi affitti per affittare più spesso. Le tue tariffe di host rimangono fisse, quindi la tua rete rimane forte.`,
  en_moyenne__c_est_environ___annualhostcase_average: `In media, si tratta di un risparmio annuo di circa {{savings}}EUR rispetto alle piattaforme basate su commissioni.`,
  hypoth_ses__100eur_la_nuit__30eur_de_m_nage__dur_e: `Ipotesi: 100EUR a notte, 30EUR pulizia, durata media 3 notti, tariffa di prenotazione annuale 50%.`,
  traveltrok_collecte_uniquement_les_donn_es_n_cessa: `DONKEY TRAVEL raccoglie solo i dati necessari per il funzionamento del servizio: account, profilo, scambi e supporto.`,
  vos_donn_es_ne_sont_partag_es_qu_avec_les_services: `I tuoi dati vengono condivisi solo con i servizi tecnici essenziali (autenticazione, hosting, sicurezza) e non vengono mai rivenduti.`,
  vous_pouvez_demander_la_mise___jour_ou_la_suppress: `Puoi richiedere di aggiornare o cancellare i tuoi dati personali dal tuo account o contattando il supporto.`,
  "help.faq.q1.question": "Quanto costa l'abbonamento?",
  "help.faq.q1.answer":
    "50€/anno per il piano classico. C'è uno sconto di lancio a 25€/anno per il 2026.",
  "help.faq.q2.question": "Posso scambiare senza avere le stesse date?",
  "help.faq.q2.answer":
    "Assolutamente. Il nostro sistema di scambio flessibile consente all'ospite 1 di venire a casa dell'ospite 2 a luglio e all'ospite 2 di venire a casa dell'ospite 1 a settembre, in modo asincrono.",
  "help.faq.q3.question":
    "Il sito è davvero riservato agli host con un punteggio di 4.5 o superiore?",
  "help.faq.q3.answer":
    "Sì. Donkey Travel è un club chiuso. Al momento della registrazione, verifichiamo il link al tuo annuncio Airbnb per garantire che il tuo punteggio medio sia di almeno 4.5/5 e che tu abbia delle recensioni.",
  "help.faq.q4.question": "Come sono organizzati gli scambi?",
  "help.faq.q4.answer":
    "Non c'è un sistema a punti. I membri decidono da soli quante notti vogliono scambiare in base al prezzo che indicano. L'annuncio Airbnb serve come riferimento per verificare se la proposta è equa e credibile.",
  "help.faq.q5.question": "Ci sono costi aggiuntivi (pulizia, servizio)?",
  "help.faq.q5.answer":
    "No! Il principio di Donkey Travel è lo scambio gratuito al 100% tra host. L'host ospitante prepara l'alloggio e l'ospite lo restituisce in condizioni di pulizia impeccabili (o gestisce la pulizia con l'host secondo i loro accordi).",
  "help.faq.q6.question": "Posso collegare più annunci Airbnb?",
  "help.faq.q6.answer":
    "Sì, questo è previsto nei nostri prossimi aggiornamenti per consentirti di sincronizzare più alloggi e ottenere ancora più opportunità di scambio.",
  "help.faq.q7.question": "Cosa succede se uno scambio viene annullato?",
  "help.faq.q7.answer":
    "In caso di annullamento, ti invitiamo a comunicare con il tuo ospite tramite la nostra messaggistica interna per trovare un nuovo accordo o nuove date.",
  "help.faq.q8.question": "Come sono garantite la fiducia e la sicurezza?",
  "help.faq.q8.answer":
    "Accettando solo host confermati (valutazione > 4.5), ci assicuriamo che tutti i membri sappiano cosa significa 'ospitare'. Inoltre, l'identità e gli annunci sono verificati dal nostro team.",
};
